import "../../stylesheets/about-package/about.less";

import * as React from "react";

type Props = {
    className?: string;
    pageheadline?: string;
    headercontent?: string | React.ReactElement<any>;
    backgroundVideo?: React.ReactElement<any>;
};

export default function AboutHeader(props: Props) {
    const {className, pageheadline, headercontent, backgroundVideo} = props;

    return (
        <header className={`title-section ${className ?? ""}`}>
            <hgroup className="title-container">
                <h1 className="title">{pageheadline}</h1>
                {headercontent}
            </hgroup>
            {backgroundVideo}
        </header>
    );
}
